// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".heatmapWrap{width:100%;height:100%;position:relative;padding:0;margin:0}", ""]);
// Exports
module.exports = exports;
